import { CostCalculationExternal } from 'generated';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import HoursDisplay from 'components/shared/cell-formatters/HoursDisplay';
import MonetaryDisplay from 'components/shared/cell-formatters/MonetaryDisplay';

const months = {
  1: 'january',
  2: 'february',
  3: 'march',
  4: 'april',
  5: 'may',
  6: 'june',
  7: 'july',
  8: 'august',
  9: 'september',
  10: 'october',
  11: 'november',
  12: 'december'
};

type CostCalculationExternalYearProperties = {
  records: CostCalculationExternal[];
};

export default function CostCalculationExternalYear(
  properties: CostCalculationExternalYearProperties
) {
  const monthRecords = properties.records;
  const { t } = useTranslation('common');

  return (
    <>
      <Grid
        container
        mt={2}
        style={{
          fontFamily: "'signikaregular', Arial, Helvetica, 'sans-serif'",
          backgroundColor: '#EEEEEE'
        }}
      >
        <Grid item xs={1}>
          {t('month')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('hours')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('km')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('totalHours')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('totalFees')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('totalTravelExpenses')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('totalVat')}
        </Grid>
        <Grid item xs={1} textAlign="right">
          {t('total')}
        </Grid>
      </Grid>
      <Grid borderBottom={1}>
        {monthRecords.map((monthRecord, index) => (
          <Grid container key={index}>
            <Grid item xs={1}>
              {t(`monthnames.${months[monthRecord.month]}`)}
            </Grid>
            <Grid item xs={1}>
              <HoursDisplay
                value={monthRecord.hours
                  .map((h) => h.hours)
                  .reduce((a, b) => a + b, 0)}
              />
            </Grid>
            <Grid item xs={1}>
              <HoursDisplay value={monthRecord.totalKm} />
            </Grid>
            <Grid item xs={1}>
              <MonetaryDisplay value={monthRecord.totalHours} />
            </Grid>
            <Grid item xs={1}>
              <MonetaryDisplay value={monthRecord.totalFees} />
            </Grid>
            <Grid item xs={1}>
              <MonetaryDisplay value={monthRecord.totalTravelExpenses} />
            </Grid>
            <Grid item xs={1}>
              <MonetaryDisplay value={monthRecord.totalVat} />
            </Grid>
            <Grid item xs={1}>
              <MonetaryDisplay value={monthRecord.total} />
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        mt={1}
        style={{
          fontFamily: "'signikaregular', Arial, Helvetica, 'sans-serif'",
          backgroundColor: '#CCCCCC'
        }}
      >
        <Grid item xs={1}>
          {t('totals')}
        </Grid>
        <Grid item xs={1}>
          <HoursDisplay
            value={monthRecords
              .map((monthRecord) =>
                monthRecord.hours.map((h) => h.hours).reduce((a, b) => a + b, 0)
              )
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <HoursDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalKm)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalHours)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalFees)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalTravelExpenses)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.totalVat)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
        <Grid item xs={1}>
          <MonetaryDisplay
            value={monthRecords
              .map((monthRecord) => monthRecord.total)
              .reduce((a, b) => a + b, 0)}
          />
        </Grid>
      </Grid>
    </>
  );
}
